import { Observable } from 'rxjs';
import { SendShippingEmailRequest, ShippingAccounting } from '../entities/shipping-accounting.entity';
import { ShippingAccountingList } from '../models/shipping-accounting-list.model';

export abstract class ShippingAccountingRepository {
  abstract getList(query: string): Observable<ShippingAccountingList>;
  abstract sendEmail(request: SendShippingEmailRequest): Observable<void>;
  abstract downloadCsv(professionalId: string, startDate: string, endDate: string): Observable<Blob>;
}
